// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19tWq","left":"styles_left__1GBwJ","desktopActions":"styles_desktopActions__1HGl_","title":"styles_title__19ira"};